<template>
  <div id="capacityData">
    <!-- 顶部卡片 -->
    <el-card style="margin-bottom: 16px" v-loading="cardLoading">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="4">
          <el-statistic
            group-separator=","
            :precision="0"
            :value="driverData.createdNum"
            title="总计注册(人)"
          ></el-statistic>
        </el-col>
        <el-col :span="4">
          <div>
            <el-statistic
              group-separator=","
              :precision="0"
              :value="driverData.applyNum"
              title="等待认证(人)"
            ></el-statistic>
          </div>
        </el-col>
        <el-col :span="4">
          <div>
            <el-statistic
              group-separator=","
              :precision="0"
              :value="driverData.auditNum"
              title="等待审核(人)"
            ></el-statistic>
          </div>
        </el-col>
        <el-col :span="4">
          <div>
            <el-statistic
              group-separator=","
              :precision="0"
              :value="driverData.driverNum"
              title="认证通过(人)"
            ></el-statistic>
          </div>
        </el-col>
        <el-col :span="4">
          <div>
            <el-statistic
              group-separator=","
              :precision="0"
              :value="driverData.bannedNum"
              title="封禁司机(人)"
            ></el-statistic>
          </div>
        </el-col>
        <el-col :span="4">
          <div>
            <el-statistic
              group-separator=","
              :precision="0"
              :value="driverData.activeNum"
              title="本月上线(人)"
            ></el-statistic>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 注册趋势图表 -->
    <el-row style="margin-top: 16px">
      <div class="flex-between">
        <span>注册趋势</span>
        <div class="search">
          <el-radio-group
            style="margin-left: 10px"
            size="mini"
            v-model="register.timeType"
            @change="radioChange($event, 'register')"
          >
            <el-radio-button :label="7">最近7天</el-radio-button>
            <el-radio-button :label="30">最近30天</el-radio-button>
            <el-radio-button :label="180">最近半年</el-radio-button>
            <el-radio-button :label="365">最近一年</el-radio-button>
            <el-radio-button :label="0">从始至终</el-radio-button>
          </el-radio-group>
          <el-date-picker
            style="width: 240px; margin-left: 5px"
            v-model="register.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            :picker-options="datePickerOptions"
            @change="dateChange($event, 'register')"
          >
          </el-date-picker>
        </div>
      </div>
      <el-col :span="24" style="height: 300px">
        <lineChart
          ref="registerLineChart"
          id="registerLineChart"
          :option="registerOption"
        ></lineChart>
      </el-col>
    </el-row>

    <!-- 运力趋势图表 -->
    <el-row style="margin-top: 16px">
      <div class="flex-between">
        <div>运力趋势</div>
        <div class="search">
          <el-select
            v-model="auth.startCityCode"
            placeholder="全部城市"
            filterable
            clearable
            @change="cityChange"
          >
            <el-option
              v-for="val in cityList"
              :key="val.value"
              :value="val.value"
              :label="val.label"
            >
            </el-option>
          </el-select>
          <el-radio-group
            style="margin-left: 10px"
            size="mini"
            v-model="auth.timeType"
            @change="radioChange($event, 'auth')"
          >
            <el-radio-button :label="7">最近7天</el-radio-button>
            <el-radio-button :label="30">最近30天</el-radio-button>
            <el-radio-button :label="180">最近半年</el-radio-button>
            <el-radio-button :label="365">最近一年</el-radio-button>
            <el-radio-button :label="0">从始至终</el-radio-button>
          </el-radio-group>
          <el-date-picker
            style="width: 240px; margin-left: 5px"
            v-model="auth.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            :picker-options="datePickerOptions"
            @change="dateChange($event, 'auth')"
          >
          </el-date-picker>
        </div>
      </div>
      <el-col :span="24" style="height: 300px">
        <lineChart
          ref="authLineChart"
          id="authLineChart"
          :option="authOption"
        ></lineChart>
      </el-col>
    </el-row>

    <!-- 运力分布表格 -->
    <el-row style="margin-top: 16px">
      <div class="flex-between">
        <span>运力分布</span>
        <div class="search">
          <el-radio-group
            style="margin-left: 10px"
            size="mini"
            v-model="authTable.timeType"
            @change="radioChange($event, 'authTable')"
          >
            <el-radio-button :label="7">最近7天</el-radio-button>
            <el-radio-button :label="30">最近30天</el-radio-button>
            <el-radio-button :label="180">最近半年</el-radio-button>
            <el-radio-button :label="365">最近一年</el-radio-button>
            <el-radio-button :label="0">从始至终</el-radio-button>
          </el-radio-group>
          <el-date-picker
            style="width: 240px; margin-left: 5px"
            v-model="authTable.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            :picker-options="datePickerOptions"
            @change="dateChange($event, 'authTable')"
          >
          </el-date-picker>
        </div>
      </div>
      <el-table
        border
        v-loading="authTableOption.loading"
        :data="authTableOption.list"
        style="margin: 16px 0"
      >
        <el-table-column
          v-for="item in authTableOption.columns"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
        ></el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { cityCodeJson } from "@/assets/js/city";
import lineChart from "./components/lineChart.vue";
export default {
  name: "coreData",
  components: {
    lineChart,
  },
  data() {
    let arr = [];
    cityCodeJson.forEach((pre) => {
      if (pre.districts) {
        arr.push(...pre.districts);
      }
    });
    arr.forEach((item) => {
      item.label = item.name;
      item.value = item.citycode;
    });
    return {
      cityList: arr,
      cardLoading: false,
      driverData: {
        createdNum: 0,
        applyNum: 0,
        auditNum: 0,
        driverNum: 0,
        bannedNum: 0,
        activeNum: 0,
      },
      register: {
        timeType: 7,
        date: null,
      },
      auth: {
        startCityCode: null,
        timeType: 7,
        date: null,
      },
      authTable: {
        timeType: 7,
        date: null,
      },
      registerOption: {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["新增注册"],
          bottom: "1%",
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "9%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "新增注册",
            type: "line",
            data: [],
            smooth: true,
          },
        ],
      },
      authOption: {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["提交认证", "认证通过", "当日上线"],
          bottom: "1%",
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "9%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "提交认证",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "认证通过",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "当日上线",
            type: "line",
            data: [],
            smooth: true,
          },
        ],
      },
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

      authTableOption: {
        loading: false,
        list: [],
        columns: [
          { prop: "receivingCity", label: "接单城市" },
          { prop: "applyNum", label: "提交认证(人)" },
          { prop: "applyTotal", label: "占比" },
          { prop: "auditNum", label: "认证通过(人)" },
          { prop: "auditTotal", label: "占比" },
          { prop: "activeNum", label: "上线司机(人)" },
          { prop: "activeTotal", label: "占比" },
        ],
      },
    };
  },
  computed: {
    // ...mapGetters({
    //   cityList: "allCityListGetter",
    // }),
  },
  methods: {
    calculatePercentage(numerator, denominator) {
      if (numerator === 0 || denominator === 0) {
        return "0%";
      }
      return ((numerator / denominator) * 100).toFixed(0) + "%";
    },
    async getDriverData() {
      this.cardLoading = true;
      const url = "/api/v1/manage/hitchRide/statistics/driver";
      const { code, data } = await this.$axios.get(url);
      if (code === 1) {
        this.driverData = data;
      }
      this.cardLoading = false;
    },
    // 获取注册图表数据
    async registerSearch() {
      const url = "/api/v1/manage/hitchRide/statistics/driver/register";
      const params = {
        startTime: this.register.date ? this.register.date[0] / 1000 : null,
        endTime: this.register.date ? this.register.date[1] / 1000 : null,
      };
      const { code, data } = await this.$axios.get(url, params);
      if (code === 1) {
        this.registerOption.xAxis.data = data.map(
          (item) => item.statisticsTime
        );
        this.registerOption.series[0].data = data.map(
          (item) => item.createdNum
        );
        this.$refs.registerLineChart.initChart();
      }
    },
    // 获取运力图表数据
    async authSearch() {
      const url = "/api/v1/manage/hitchRide/statistics/driver/time";
      const params = {
        startCityCode: this.auth.startCityCode,
        startTime: this.auth.date ? this.auth.date[0] / 1000 : null,
        endTime: this.auth.date ? this.auth.date[1] / 1000 : null,
      };
      const { code, data } = await this.$axios.get(url, params);
      if (code === 1) {
        this.authOption.xAxis.data = data.map((item) => item.statisticsTime);
        this.authOption.series[0].data = data.map((item) => item.applyNum);
        this.authOption.series[1].data = data.map((item) => item.auditNum);
        this.authOption.series[2].data = data.map((item) => item.activeNum);
        this.$refs.authLineChart.initChart();
      }
    },
    // 获取运力表格数据
    async authTableSearch() {
      const url = "/api/v1/manage/hitchRide/statistics/driver/city";
      const params = {
        startTime: this.authTable.date ? this.authTable.date[0] / 1000 : null,
        endTime: this.authTable.date ? this.authTable.date[1] / 1000 : null,
      };
      this.authTableOption.loading = true;
      const { code, data } = await this.$axios.get(url, params);
      if (code === 1) {
        this.authTableOption.list = data.map((item) => {
          return {
            ...item,
            applyTotal: this.calculatePercentage(item.applyNum, data.reduce((acc, val) => acc + val.applyNum, 0)),
            auditTotal: this.calculatePercentage(item.auditNum, data.reduce((acc, val) => acc + val.auditNum, 0)),
            activeTotal: this.calculatePercentage(item.activeNum, data.reduce((acc, val) => acc + val.activeNum, 0)),
          };
        });
      }
      this.authTableOption.loading = false;
    },
    /**
     * 快捷选择日期
     * @param {Number} val 天数
     */
    setDate(val = 7, key) {
      if (val) {
        const nowDate = new Date().setHours(0, 0, 0, 0);
        const startTime = nowDate - 3600 * 1000 * 24 * val + 3600 * 1000 * 24;
        const endTime = new Date().setHours(23, 59, 59, 0);
        const end = new Date().setTime(endTime);
        const start = new Date().setTime(startTime);
        this[key].date = [start, end];
      } else if (val === 0) {
        this[key].date = null;
      }
    },

    cityChange(val) {
      this.authSearch();
    },
    // 快捷日期改变
    radioChange(val, key) {
      this.setDate(val, key);
      const keyFn = key + "Search";
      this[keyFn]();
    },
    // 日期改变
    dateChange(val, key) {
      if (!val) {
        this[key].timeType = 7;
        this.setDate(7, key);
      } else {
        this[key].timeType = null;
        this[key].date = [
          new Date(val[0]).setHours(0, 0, 0, 0),
          new Date(val[1]).setHours(23, 59, 59, 0),
        ];
      }
      const keyFn = key + "Search";
      this[keyFn]();
    },
  },
  mounted() {
    this.getDriverData();
    this.setDate(7, "register");
    this.registerSearch();
    this.setDate(7, "auth");
    this.authSearch();
    this.setDate(7, "authTable");
    this.authTableSearch();
  },
};
</script>

<style lang="less">
#capacityData {
  padding-bottom: 16px;
  .search {
    display: flex;
    align-items: center;
  }
  .el-statistic .title {
    font-size: 14px;
  }
  .el-statistic .number {
    color: #409eff;
  }
}
</style>
